
import {clsx} from 'external/clsx'
import { Link, useMemo } from 'external/react'

import ButtonBack from 'components/ButtonBack'

import usePayment from 'context/payment-context/hook'
import usePublic from 'context/public-context/hook'

export default function LanguageBar() {

    const {cart} = usePayment()
    const {navigation, params, query: {languageId}, offerData: {courses = []}} = usePublic()

    const backLink = useMemo(() => navigation.offer.link(), [navigation])

    const [toES, toEN] = useMemo(() =>
        navigation.offerSubjects.active
            ? [ navigation.offerSubjects.linkWithQuery({languageId: 'es'}),
                navigation.offerSubjects.linkWithQuery({languageId: 'en'})]
            : []
        , [navigation])
    
    const [englishCount, spanishCount] = useMemo(() => {
        const selectedSubjects = (cart.properties[params.typeSubject] || []).filter(id => id)
        const english = courses.filter(({language, subject}) => language === 'en' && selectedSubjects.indexOf(subject) < 0).length 
        const spanish =  courses.filter(({subject, language}) => language == 'es' && selectedSubjects.indexOf(subject) < 0).length
        return [english, spanish]
    }, [cart.properties, courses, params.typeSubject])
    
	return (
        <div className='bodyHeader_subject'>
            <ButtonBack path={backLink} />
            <div>
                {spanishCount > 0 && (<Link to={toES} className={clsx('language__filter', 'mx-1', {selected: languageId === 'es'})}>Español</Link>)}
                {englishCount > 0 && (<Link to={toEN} className={clsx('language__filter', 'mx-1', {selected: languageId === 'en'})}>Inglés</Link>)}
            </div>
        </div>
    )
}